export enum FedopsInteractions {
  queryAvailability = 'query-availability',
  calculateMultiSlotAvailability = 'calculate-multi-slot-availability',
}
